import React from 'react';

type Props = {
  isFullscreen: boolean;
  onToggle: () => void;
  className?: string;
};

const DEFAULT_BTN = 'inline-flex items-center gap-1 h-8 px-2 rounded-lg border border-gray-300/60 bg-white text-[12px] leading-none hover:bg-gray-50 active:scale-[0.99] transition disabled:opacity-50 disabled:cursor-not-allowed';

const FullscreenToggle: React.FC<Props> = ({ isFullscreen, onToggle, className = DEFAULT_BTN }) => {
  return (
    <button className={className} onClick={onToggle} title="Fullscreen">
      <span className={`e-icons ${isFullscreen ? 'e-exit-full-screen' : 'e-full-screen'}`} />
    </button>
  );
};

export default FullscreenToggle;
